import { render } from "./DynamicDetailList.vue?vue&type=template&id=60287c16&scoped=true&ts=true"
import script from "./DynamicDetailList.vue?vue&type=script&lang=ts"
export * from "./DynamicDetailList.vue?vue&type=script&lang=ts"

import "./DynamicDetailList.vue?vue&type=style&index=0&id=60287c16&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60287c16"]])

export default __exports__